import { initChallengeForm } from '@/scripts/challenges/challenge-form';

function init() {
  const form = document.querySelector<HTMLElement>('[data-challenge-form]');
  
  if (form) {
    initChallengeForm(form);
  }
}

init();
